import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import medicalRecordService from "../../services/medicalRecordService";

export const fetchMedicalRecords = createAsyncThunk(
  "medicalRecords/fetchMedicalRecords",
  async () => {
    return await medicalRecordService.getMedicalRecords();
  },
);

export const addMedicalRecord = createAsyncThunk(
  "medicalRecords/addMedicalRecord",
  async (recordData) => {
    return await medicalRecordService.createMedicalRecord(recordData);
  },
);

export const updateMedicalRecordData = createAsyncThunk(
  "medicalRecords/updateMedicalRecordData",
  async ({ id, recordData }) => {
    return await medicalRecordService.updateMedicalRecord(id, recordData);
  },
);

export const removeMedicalRecord = createAsyncThunk(
  "medicalRecords/removeMedicalRecord",
  async (id) => {
    await medicalRecordService.deleteMedicalRecord(id);
    return id;
  },
);

const medicalRecordSlice = createSlice({
  name: "medicalRecords",
  initialState: {
    records: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMedicalRecords.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMedicalRecords.fulfilled, (state, action) => {
        state.loading = false;
        state.records = action.payload;
      })
      .addCase(fetchMedicalRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addMedicalRecord.fulfilled, (state, action) => {
        state.records.push(action.payload);
      })
      .addCase(removeMedicalRecord.fulfilled, (state, action) => {
        state.records = state.records.filter(
          (r) => r.record_id !== action.payload,
        );
      });
  },
});

export default medicalRecordSlice.reducer;
